<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  (validate)="onValidate($event)"
>
  <section [formGroup]="getControl('data')">
    <p [innerHTML]="'KATIE_BECKETT_STATIC_TEXT1' | globalTranslate"></p>
    <p>
      {{ "KATIE_BECKETT_STATIC_TEXT2" | globalTranslate }}
      {{ selectedChild?.name?.fullName
      }}{{ "KATIE_BECKETT_STATIC_TEXT3" | globalTranslate }}
    </p>
    <p>{{ "KATIE_BECKETT_STATIC_TEXT4" | globalTranslate }}</p>
    <p>{{ "KATIE_BECKETT_STATIC_TEXT5" | globalTranslate }}</p>
    <h1 class="section-header">
      {{ "KATIE_BECKETT_STATIC_TEXT6" | globalTranslate }}
    </h1>
    <hr />
    <nh-field
      id="kt_houseMember"
      label="{{ 'KATIE_BECKETT_STATIC_TEXT7' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="houseMember"
        [attr.disabled]="exported ? true : null"
        [items]="individuals18Under"
        bindValue="identifier"
        bindLabel="name.fullName"
        formControlName="houseMember"
        [attr.aria-labelledby]="'kt_houseMember'"
        aria-required="true"
      ></select>
    </nh-field>
    <br />
    @if (this.appType === 'RC' && this.showKbQuestion === true) {
    <div>
      <h2 class="section-header">
        {{ "KATIE_BECKETT_STATIC_TEXT30" | globalTranslate }}
      </h2>
      <hr />
      <nh-field
        id="kt_kbChange"
        label="{{ 'KATIE_BECKETT_STATIC_TEXT31' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="kbChange"
          [items]="tableCodeValue('MPKBCHNG', 'data.kbChange')"
          formControlName="kbChange"
          [attr.aria-labelledby]="'kt_kbChange'"
        ></select>
      </nh-field>
      <br />
    </div>
    }
    <h2 class="section-header">
      {{ "KATIE_BECKETT_STATIC_TEXT8" | globalTranslate }}
    </h2>
    <hr />
    <div class="mb-2 pb-2 pt-2">
      <label for="reasonsForApplyingToKb" id="reasonsForApplyingToKb-label"
        ><span class="text-danger" aria-hidden="true">*</span
        ><span class="visually-hidden">{{ "required" | globalTranslate }}</span>
        {{ "KATIE_BECKETT_STATIC_TEXT9" | globalTranslate }}
        {{ selectedChild?.name?.fullName
        }}{{ "KATIE_BECKETT_STATIC_TEXT10" | globalTranslate }}
      </label>
      <div class="hint">
        {{ "KATIE_BECKETT_STATIC_TEXT11" | globalTranslate }}
      </div>
      <nh-checkbox-list
        uniqueString="reasons"
        [checkboxGroup]="getControl('extras.helpers.reasonsForApplyingToKb')"
        [referenceTable]="tables.MPAPLKBRSN"
        (change)="onReasonSelect($event)"
        role="group"
        aria-labelledby="reasonsForApplyingToKb-label"
        aria-describedby="reasonsForApplyingToKb-required"
        [fromCheckboxList]="true"
      ></nh-checkbox-list>
    </div>
    @if (!isReasonSelected) {
    <span
      class="form-text invalid-name d-block"
      role="alert"
      aria-live="polite"
      >{{ "REQUIRED" | globalTranslate }}</span
    >
    }
    <br />

    @if (!isDonotWantToContinueSelected) {
    <section>
      <h2 class="section-header">
        {{ "KATIE_BECKETT_STATIC_TEXT12" | globalTranslate }}
      </h2>
      <hr />
      <p>{{ "KATIE_BECKETT_STATIC_TEXT13" | globalTranslate }}</p>
      <label for="contact details" id="contact-details-label"
        ><span class="text-danger" aria-hidden="true">*</span
        ><span class="visually-hidden">{{ "required" | globalTranslate }}</span
        >{{ "KATIE_BECKETT_STATIC_TEXT14" | globalTranslate }}
        {{ selectedChild?.name?.fullName
        }}{{ "KATIE_BECKETT_STATIC_TEXT15" | globalTranslate }}
      </label>
      <div>
        <div class="row align-items-center p-3">
          <div
            class="{{
              headSelected
                ? 'col card ktbecketta-address-card-selected'
                : 'col card ktbecketta-address-card'
            }}"
          >
            <div
              class="card-body p-3 p-md-4 d-flex flex-column flex-md-row align-items-center text-center text-md-start"
              (click)="contactAddressDetails('HOH')"
            >
              <div
                class="mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
              >
                <img
                  class="col dot"
                  aria-label="primaryIndividual1"
                  alt=""
                  aria-hidden="true"
                  src="../../../../../assets/images/Icons/KBReferralTileIcon.svg"
                />
              </div>
              <div class="flex-grow-1 min-w-0 w-100">
                <div class="section-column">
                  <h2 tabindex="0" class="tile_header">
                    <strong>{{ primaryIndividual?.name?.fullName }}</strong>
                  </h2>
                  @if (primaryIndividual?.physicalAddress[0]?.address) {
                  <div>
                    <p class="card-text">
                      {{
                        primaryIndividual?.physicalAddress[0]?.address
                          ?.addressLine1
                      }}
                    </p>
                    <p class="card-text">
                      {{
                        primaryIndividual?.physicalAddress[0]?.address
                          ?.addressLine2
                      }}
                    </p>
                    <p class="card-text">
                      {{
                        primaryIndividual?.physicalAddress[0]?.address?.city
                      }},
                      {{
                        primaryIndividual?.physicalAddress[0]?.address?.state
                          ?.code
                      }}
                      {{ this.hohZip }}
                    </p>
                    <p class="card-text">{{ physicalHomeNumber }}</p>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        @if (primaryIndividual?.assistingPerson?.name?.fullName) {
        <div class="row align-items-center p-3">
          <div
            class="{{
              assistantSelected
                ? 'col card ktbecketta-address-card-selected'
                : 'col card ktbecketta-address-card'
            }}"
          >
            <div class="row card-body" (click)="contactAddressDetails('ATH')">
              <div class="row align-items-center ps-3">
                <img
                  class="col dot"
                  aria-label="primaryIndividual2"
                  src="../../../../../assets/images/Icons/KBReferralTileIcon.svg"
                />
              </div>
              <div class="section-column">
                <h2 class="tile_header">
                  <strong>{{
                    primaryIndividual?.assistingPerson?.name?.fullName
                  }}</strong>
                </h2>
                <p class="card-text">
                  {{
                    primaryIndividual?.assistingPerson?.address?.addressLine1
                  }}
                </p>
                <p class="card-text">
                  {{
                    primaryIndividual?.assistingPerson?.address?.addressLine2
                  }}
                </p>
                @if (primaryIndividual?.assistingPerson?.address?.city) {
                <p class="card-text">
                  {{ primaryIndividual?.assistingPerson?.address?.city }},
                  {{
                    primaryIndividual?.assistingPerson?.address?.state?.code
                  }}
                  {{ this.assisZip }}
                </p>
                } @if
                (primaryIndividual?.assistingPerson?.address?.addrApoFpo?.value)
                {
                <p class="card-text">
                  {{
                    primaryIndividual?.assistingPerson?.address?.addrApoFpo
                      ?.value
                  }},
                  {{
                    primaryIndividual?.assistingPerson?.address?.addrAaAeAp
                      ?.value
                  }}
                  {{ primaryIndividual?.assistingPerson?.address?.zip }}
                </p>
                }
                <p class="card-text">{{ assistingHomeNumber }}</p>
              </div>
            </div>
          </div>
        </div>
        }
        <div class="row align-items-center p-3">
          <div
            class="{{
              otherSelected
                ? 'col card ktbecketta-address-card-other-selected'
                : 'col card ktbecketta-address-card-other'
            }}"
          >
            <div class="card-body" (click)="contactAddressDetails('OTH')">
              <h2 class="tile_header" tabindex="0">
                <strong>{{
                  "KATIE_BECKETT_STATIC_TEXT16" | globalTranslate
                }}</strong>
              </h2>
            </div>
          </div>
        </div>
      </div>
      @if (!headSelected && !assistantSelected && !otherSelected) {
      <span
        class="form-text invalid-name d-block"
        role="alert"
        aria-live="polite"
        >{{ "REQUIRED" | globalTranslate }}</span
      >
      }
      <br />
      @if (isOtherPersonInformationEnabled) {
      <section [formGroup]="getControl('data.contactInformation')">
        <nh-name-address
          [addressname]="'kt_contactInformation'"
          [personalName]="getControl('data.contactInformation.name')"
          [showPopup]="false"
          [tables]="tables"
        >
        </nh-name-address>
        <br />
        @if (isEnabled('data.contactInformation.contactPhones')) {
        <nh-contact-phones
          [contactPhoneName]="'kt_contactPhones'"
          [phoneNumbers]="getControl('data.contactInformation.contactPhones')"
        ></nh-contact-phones>
        } @if (isEnabled('data.contactInformation.kbContactEmail')) {
        <nh-field
          id="kt_kbContactEmail"
          label="{{ 'KATIE_BECKETT_STATIC_TEXT17' | globalTranslate }}"
          class="label-section"
        >
          <input
            type="text"
            name="kbContactEmail"
            formControlName="kbContactEmail"
            [attr.aria-labelledby]="'kt_kbContactEmail'"
            class="form-control"
            placeholder="name@address.com"
            maxlength="63"
          />
        </nh-field>
        }
      </section>
      } @if (isEnabled('data.kbContactRelationship')) {
      <nh-field
        id="kt_kbContactRelationship"
        label="{{ 'KATIE_BECKETT_STATIC_TEXT18' | globalTranslate }} {{
          selectedChild?.name?.fullName
        }}? "
        class="label-section"
      >
        <select
          nhTranslate
          name="kbContactRelationship"
          [items]="tableCodeValue('PRIMCONTREL', 'data.kbContactRelationship')"
          [attr.aria-labelledby]="'kt_kbContactRelationship'"
          formControlName="kbContactRelationship"
        ></select>
      </nh-field>
      } @if (isEnabled('data.kbContactInterpreterSwitch')) {
      <nh-field
        id="kt_kbContactInterpreterSwitch"
        label="{{ 'KATIE_BECKETT_STATIC_TEXT19' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="kbContactInterpreterSwitch"
          [items]="tableCodeValue('YESNO', 'data.kbContactInterpreterSwitch')"
          [attr.aria-labelledby]="'kt_kbContactInterpreterSwitch'"
          formControlName="kbContactInterpreterSwitch"
        ></select>
      </nh-field>
      } @if (isEnabled('data.kbContactLanguage')) {
      <nh-field
        id="kt_kbContactLanguage"
        label="{{ 'KATIE_BECKETT_STATIC_TEXT20' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="kbContactLanguage"
          [items]="tableCodeValue('PRIMARYLANGUAGE', 'data.kbContactLanguage')"
          [attr.aria-labelledby]="'kt_kbContactLanguage'"
          formControlName="kbContactLanguage"
        ></select>
      </nh-field>
      }
      <h2 class="section-header">
        {{ "KATIE_BECKETT_STATIC_TEXT21" | globalTranslate }}
      </h2>
      <hr />
      <section [formGroup]="getControl('data.livingArrangement')">
        <div class="mb-2 pb-2 pt-2">
          <label
            for="pastYearLivingArrangement"
            id="pastYearLivingArrangement-label"
            ><span class="text-danger" aria-hidden="true">*</span
            ><span class="visually-hidden">{{
              "required" | globalTranslate
            }}</span
            >{{ "HAS_1" | globalTranslate }}{{ selectedChild?.name?.fullName }}
            {{ "KATIE_BECKETT_STATIC_TEXT22" | globalTranslate }}</label
          >
          <div class="hint">
            {{ "KATIE_BECKETT_STATIC_TEXT11" | globalTranslate }}
          </div>
          <nh-checkbox-list
            uniqueString="living"
            [checkboxGroup]="
              getControl('extras.helpers.pastYearLivingArrangement')
            "
            [referenceTable]="tables.MPKBLIVING"
            (change)="onPastYearLivArrangementSelect($event)"
            role="group"
            aria-labelledby="pastYearLivingArrangement-label"
            aria-describedby="pastYearLivingArrangement-required"
            [fromCheckboxList]="true"
          ></nh-checkbox-list>
        </div>
        @if (!isPastYearLivArrangementSelected) {
        <span
          class="form-text invalid-name d-block"
          role="alert"
          aria-live="polite"
          >{{ "REQUIRED" | globalTranslate }}</span
        >
        }
        <br />
        @if (isEnabled('data.livingArrangement.currentLivingArrangement')) {
        <nh-field
          id="kt_currentLivingArrangement"
          label="{{ 'KATIE_BECKETT_STATIC_TEXT23' | globalTranslate }} {{
            selectedChild?.name?.fullName
          }} {{ 'KATIE_BECKETT_STATIC_TEXT24' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="currentLivingArrangement"
            [items]="
              tableCodeValue(
                'MPKBLIVINGNOW',
                'data.livingArrangement.currentLivingArrangement'
              )
            "
            formControlName="currentLivingArrangement"
            [attr.aria-labelledby]="'kt_currentLivingArrangement'"
          ></select>
        </nh-field>
        }
        <!-- new field for physical address -->
        <!-- <section>
                        <div [formGroup]="getControl('data.livingArrangement')" *ngIf="isEnabled('data.livingArrangement.kbOtherAddressFormat')">
                          <p>{{'WHAT_IS' | globalTranslate }}{{selectedChild?.name?.fullName}}{{'KATIE_BECKETT_STATIC_TEXT28' | globalTranslate }}</p>
                          <div *ngIf="isEnabled('data.livingArrangement.kbOtherAddressFormat')">
                            <nh-field id = "kt_kbOtherAddressFormat" name="kbOtherAddressFormat" label="{{'ADDRESS_FORMAT' | globalTranslate }}" class="label-section">
                              <select nhTranslate aria-label="kbOtherAddressFormat" name="kbOtherAddressFormat" [items]="tables.ADDRESSFORMATTYPES"
                              formControlName="kbOtherAddressFormat"></select>
                            </nh-field>
                          </div>
                          <nh-name-address [addressname] = "'kt_kbOtherAddressFormat'" *ngIf="isEnabled('data.livingArrangement.otherAddress')"
                            [addressFormat]="getControl('data.livingArrangement.kbOtherAddressFormat')"
                            [address]="getControl('data.livingArrangement.otherAddress')" [showPopup]="false" [tables]="tables">
                          </nh-name-address><br>
                        </div>
                      </section> -->
        @if (isEnabled('data.livingArrangement.kbOtherPhysicalAddressSwitch')) {
        <nh-field
          id="kt_kbOtherPhysicalAddressSwitch"
          label="{{ 'DOES_2' | globalTranslate }}{{
            selectedChild?.name?.fullName
          }} {{ 'KATIE_BECKETT_STATIC_TEXT25' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            (change)="
              addressSwitch(
                this.getControl(
                  'data.livingArrangement.kbOtherPhysicalAddressSwitch'
                )
              )
            "
            name="kbOtherPhysicalAddressSwitch"
            [items]="
              tableCodeValue(
                'YESNO',
                'data.livingArrangement.kbOtherPhysicalAddressSwitch'
              )
            "
            formControlName="kbOtherPhysicalAddressSwitch"
            [attr.aria-labelledby]="'kt_kbOtherPhysicalAddressSwitch'"
          ></select>
        </nh-field>
        }
        <section>
          @if (isEnabled('data.livingArrangement.kbAddressFormat')) {
          <div [formGroup]="getControl('data.livingArrangement')">
            <p>
              {{ "KATIE_BECKETT_STATIC_TEXT26" | globalTranslate }}
              {{ selectedChild?.name?.fullName }}.
              {{ "KATIE_BECKETT_STATIC_TEXT27" | globalTranslate }}
              {{ selectedChild?.name?.fullName
              }}{{ "KATIE_BECKETT_STATIC_TEXT28" | globalTranslate }}
            </p>
            @if (isEnabled('data.livingArrangement.kbAddressFormat')) {
            <div>
              <nh-field
                id="kt_kbAddressFormat"
                name="kbAddressFormat"
                label="{{ 'ADDRESS_FORMAT' | globalTranslate }}"
                class="label-section"
              >
                <select
                  nh
                  name="kbAddressFormat"
                  [items]="tables.ADDRESSFORMATTYPES"
                  formControlName="kbAddressFormat"
                  [attr.aria-labelledby]="'kt_kbAddressFormat'"
                ></select>
              </nh-field>
            </div>
            } @if (isEnabled('data.livingArrangement.address')) {
            <nh-name-address
              [addressname]="'kt_kbAddressFormat'"
              [addressFormat]="
                getControl('data.livingArrangement.kbAddressFormat')
              "
              [address]="getControl('data.livingArrangement.address')"
              [showPopup]="false"
              [tables]="tables"
            >
            </nh-name-address>
            }<br />
          </div>
          }
        </section>
        @if (!this.isHideSchoolSw) {
        <nh-field
          id="kt_kbSchoolSwitch"
          label="{{ 'DOES_2' | globalTranslate }}{{
            selectedChild?.name?.fullName
          }} {{ 'KATIE_BECKETT_STATIC_TEXT29' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="kbSchoolSwitch"
            [items]="
              tableCodeValue('YESNO', 'data.livingArrangement.kbSchoolSwitch')
            "
            formControlName="kbSchoolSwitch"
            [attr.aria-labelledby]="'kt_kbSchoolSwitch'"
          ></select>
        </nh-field>
        }
      </section>
    </section>
    }
  </section>

</nh-form>